define('dialogs',['elements', 'lib/es6-promise', 'tooltip-notifier'], function(elements, promise, tooltipNotifier) {
	var container = null;
	var activeDialog = null;

	function showContainer() {
		if (!container) {
			container = $('<div>').addClass('modal-dialog-container');
			$('body').append(container);
		}
		container.show();
		$('body').addClass('modal-dialog-open');
	}

	function hideContainer() {
		if (container)
			container.hide();
		$('body').removeClass('modal-dialog-open');
	}

	function completeDialog(elem) {
		if (!elem.find('.close-dialog-button').length) {
			$('<button>')
					.addClass('close-dialog-button font-icon icon-cross')
					.click(function() {
						close(elem);
					})
					.prependTo(elem.find('.dialog-title'));
		}

		elem.find('.close-dialog-button').click(function() {
			close(elem);
		});
	}

	function show(elem, container) {
		elem
			.appendTo(container)
			.removeClass('hidden');

		return elem;
	}

	function create(id) {
		var elem = $('#' + id).clone();

		// change the ids so that there are no duplicates. required for <label>
		var idSuffix = '_' + Math.floor(Math.random() * 1000000000000);
		elem.find('[id]').each(function() {
			$(this).attr('id', $(this).attr('id') + idSuffix);
		});
		elem.find('[for]').each(function() {
			$(this).attr('for', $(this).attr('for') + idSuffix);
		});

		elements.enable(elem);
		completeDialog(elem);

		return elem;
	}

	function showModal(elem) {
		showContainer();
		show(elem, container);
		activeDialog = elem;
	}

	function close(elem) {
		elem.remove();
		hideContainer();
		activeDialog = null;
	}

	function openURL(url) {
		var outer = $('<div>').prop('id', 'dialog').addClass('hidden dialog');
		var title = $('<div>').addClass('dialog-title');
		var body = $('<div>').addClass('dialog-body');
		outer.append(title);
		outer.append(body);

		$('body').append(outer);
		var dialog = create('dialog');

		dialog.opened = new promise.Promise(function(resolve, reject) {
			$.ajax({
				url: url,
				type: 'GET',
				dataType: 'json'
			}).done(function(data) {
				showModal(dialog);
				setDialogHTML(dialog, data.html, data.title);
				resolve();
			}).fail(function(xhr) {
				alert('Beim Öffnen des Dialogs ist ein Fehler aufgetreten.');
				reject(xhr);
			});
		});

		return dialog;
	}

	function onTargetFormSubmitted(e) {
		e.preventDefault();
		var form = $(this);
		var status;
		var dialog = e.data.dialog;
		var eventData;
		var new_html;
		var new_title;

		$.ajax({
			url: form.attr('action'),
			type: 'POST',
			dataType: 'json',
			data: form.serialize() + '&submit=1'
		}).done(function(data) {
				status = 200;
				eventData = data;
				new_html = data.html;
				new_title = data.title;
		}).fail(function(xhr) {
			try {
				var json = $.parseJSON(xhr.responseText);
			} catch (e) {
				tooltipNotifier.showError(form, 'Beim Abschicken des Formulars ist ein Fehler aufgetreten.', xhr);
				throw e;
			}
			if (json.error) {
				tooltipNotifier.showError(form, '', xhr);
				return;
			}
			status = xhr.status;
			eventData = json;
			new_html = json.html;
			new_title = json.title;
		}).always(function() {
			dialog.trigger('submitFormResponse', [status, eventData]);
			setDialogHTML(dialog, new_html);
		});
	}

	function setDialogHTML(dialog, html, title) {
		dialog.find('.dialog-body').html(html);
		dialog.find('form[target=_dialog]').submit({dialog: dialog}, onTargetFormSubmitted);
		completeDialog(dialog);
		dialog.find('.dialog-title').prepend(title);
	}

	$(document).keydown(function(e) {
		if (e.which == 27 && activeDialog) {
			close(activeDialog);
		}
	});

	return {
		showModal: showModal,
		close: close,
		create: create,
		openURL: openURL
	};
});

